/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { RestoreRequestBuilderRequestsMetadata, type RestoreRequestBuilder } from './restore/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/images/trash
 */
export interface TrashRequestBuilder extends BaseRequestBuilder<TrashRequestBuilder> {
    /**
     * The restore property
     */
    get restore(): RestoreRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const TrashRequestBuilderUriTemplate = "{+baseurl}/api/images/trash";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const TrashRequestBuilderNavigationMetadata: Record<Exclude<keyof TrashRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    restore: {
        requestsMetadata: RestoreRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
